/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Steps_BodyInputs */

const en_svc_n8n_steps_body = /** @type {(inputs: Svc_N8n_Steps_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A workflow nobody understands six months later is a liability, so the build includes the documentation.`)
};

const lv_svc_n8n_steps_body = /** @type {(inputs: Svc_N8n_Steps_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darba plūsma, ko pēc pusgada neviens nesaprot, ir risks, tāpēc izstrāde ietver arī dokumentāciju.`)
};

/**
* | output |
* | --- |
* | "A workflow nobody understands six months later is a liability, so the build includes the documentation." |
*
* @param {Svc_N8n_Steps_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_steps_body = /** @type {((inputs?: Svc_N8n_Steps_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Steps_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_steps_body(inputs)
	return en_svc_n8n_steps_body(inputs)
});